import { create } from "zustand";
import { api, setAuthToken } from "../lib/api";

export interface UserContext {
  userId: string;
  email: string;
  role: string;
}

interface AuthState {
  user: UserContext | null;
  isLoading: boolean;
  error: string | null;
  fetchUser: (getAccessTokenSilently: () => Promise<string>) => Promise<void>;
  clear: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isLoading: false,
  error: null,

  fetchUser: async (getAccessTokenSilently) => {
    set({ isLoading: true, error: null });
    try {
      const token = await getAccessTokenSilently();
      setAuthToken(token);

      // Decode the JWT to extract user info (token is already validated by Auth0)
      const payload = JSON.parse(atob(token.split(".")[1]));
      const user: UserContext = {
        userId: payload.sub,
        email: payload["https://syncstack.ai/email"] || payload.email || "",
        role: payload["https://syncstack.ai/role"] || "user",
      };

      set({ user, isLoading: false });
    } catch (err) {
      console.error("Failed to fetch user context:", err);
      set({ error: "Failed to load user profile", isLoading: false });
    }
  },

  clear: () => {
    setAuthToken(null);
    set({ user: null, isLoading: false, error: null });
  },
}));
